<div class="filter filter-property" [class.filter-padded-left]="!standalone" style="width: 100%;">
  <span class="filter-body">
    <div class="filter-title filter-label">
      Perfect Prefixes
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
      [(ngModel)]="config.minPerfectPrefixes" (change)="updateFilter()">
    <span class="sep"></span>
    <div class="filter-title filter-label">
      Perfect Suffixes
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
      [(ngModel)]="config.minPerfectSuffixes" (change)="updateFilter()">
    <div class="spacer" style="display: table-cell; width: 100%;"></div>
  </span>
</div>
<div class="filter filter-property" [class.filter-padded-left]="!standalone" style="width: 100%;">
  <span class="filter-body">
    <div class="filter-title filter-label">
      Great+ Prefixes
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
      [(ngModel)]="config.minGreatPrefixes" (change)="updateFilter()">
    <span class="sep"></span>
    <div class="filter-title filter-label">
      Great+ Suffixes
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
      [(ngModel)]="config.minGreatSuffixes" (change)="updateFilter()">
    <div class="spacer" style="display: table-cell; width: 100%;"></div>
  </span>
</div>
<div class="filter filter-property" [class.filter-padded-left]="!standalone" style="width: 100%;">
  <span class="filter-body">
    <div class="filter-title filter-label">
      Perfect {{ isMobile() ? '' : 'Mods' }}
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
      [(ngModel)]="config.minPerfectMods" (change)="updateFilter()">
    <span class="sep"></span>
    <div class="filter-title filter-label">
      Great+ {{ isMobile() ? '' : 'Mods' }}
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
      [(ngModel)]="config.minGreatMods" (change)="updateFilter()">
    <span class="sep"></span>
    <div class="filter-title filter-label">
      Good+ {{ isMobile() ? '' : 'Mods' }}
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="min" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
      [(ngModel)]="config.minGoodMods" (change)="updateFilter()">
      <div class="spacer" style="display: table-cell; width: 100%;"></div>
  </span>
</div>
<div class="filter filter-property" [class.filter-padded-left]="!standalone" style="width: 100%;">
  <span class="filter-body">
    <div class="filter-title filter-label">
      Max. Bad {{ isMobile() ? '' : 'Mods' }}
    </div>
    <span class="sep"></span>
    <input type="number" placeholder="max" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
      [(ngModel)]="config.maxBadMods" (change)="updateFilter()">
    <div class="spacer" style="display: table-cell; width: 100%;"></div>
  </span>
</div>
